import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListenReComponent } from './listen-re.component';

const routes: Routes = [
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ListenReRoutingModule { }
